export default __webpack_public_path__ + "static/media/8_home-image.aae978ce.jpg";